/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Lucky_Sunny_Sloth_PlayInputs */

const fr_lucky_sunny_sloth_play = /** @type {(inputs: Lucky_Sunny_Sloth_PlayInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ton record actuel est de`)
};

/**

* @param {Lucky_Sunny_Sloth_PlayInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const lucky_sunny_sloth_play = /** @type {((inputs?: Lucky_Sunny_Sloth_PlayInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Lucky_Sunny_Sloth_PlayInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_lucky_sunny_sloth_play(inputs)
});